import { getEnvironmentConfiguration } from "../common/environments";

export const LoginRedirect = async () => {
  const paymentsAPIUrl = `${getEnvironmentConfiguration().payments_login_url}/login`;
  console.log("paymentsAPIUrl", paymentsAPIUrl);

  try {
    console.log("Redirecting...");
    const response = await fetch(paymentsAPIUrl, {
      method: "GET",
    }).then((res) => res.json());

    const redirectURI = response.headers.Location;
    window.location.href = redirectURI;
  } catch (error) {
    console.error("Error during login redirect:", error);
  }
};
